import React from 'react';
import { useJobSetupStore } from '@presentation/stores/JobSetupStore';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svgIcons from '@progress/kendo-svg-icons';

export const LibraryFileFormBlock: React.FC = () => {
    const libraryFiles = useJobSetupStore((state) => state.CreateJobState.libraryFiles || []);
    const setRightPanelTab = useJobSetupStore((state) => state.setRightPanelTab);
    const hasFiles = libraryFiles.length > 0;

    return (
        <fieldset className="k-form-fieldset">
            <legend className="k-form-legend">
                <strong>Library Files</strong> <SvgIcon style={{ paddingBottom: '5px' }} icon={svgIcons.fileDataIcon} />
            </legend>

            <div style={{ marginBottom: '10px' }}>
                <div
                    style={{
                        border: hasFiles ? '1px solid #ccc' : '1px solid #b81a1aff',
                        borderRadius: '3px',
                        padding: '8px',
                        minHeight: '32px',
                        backgroundColor: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '4px',
                        cursor: hasFiles ? 'default' : 'pointer',
                    }}
                    onClick={hasFiles ? undefined : () => setRightPanelTab(1)}
                    title={hasFiles ? undefined : 'Click to switch to the Libraries tab'}
                >
                    {hasFiles ? (
                        libraryFiles.map((file, idx) => (
                            <span key={idx} style={{
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #2196f3',
                                borderRadius: '3px',
                                padding: '2px 8px',
                                fontSize: '12px',
                                color: '#1976d2',
                            }}>
                                {file.path.split('/').pop()}
                            </span>
                        ))
                    ) : (
                        <span style={{ fontStyle: 'italic', fontSize: '13px' }}>
                            No library files selected — click here or switch to the <strong>Libraries</strong> tab on the right.
                        </span>
                    )}
                </div>
            </div>
        </fieldset>
    );
};
